(() => {
  if (customElements.get('sokids-product')) return;
  customElements.define('sokids-product', class extends HTMLElement {
    connectedCallback() {
      if (this.events) return;
      this.events = new AbortController();
      const options = {signal:this.events.signal};
      this.initGallery();
      this.addEventListener('keydown', event => {
        if (!event.target.matches('[role="tab"]') || !['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
        event.preventDefault(); const tabs = [...event.target.closest('[data-sp-tabs]').querySelectorAll('[role="tab"]')]; const i = tabs.indexOf(event.target);
        const index = event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length-1 : (i + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
        this.activateTab(tabs[index]); tabs[index].focus();
      }, options);
      this.addEventListener('toggle', event => {
        if (event.target.matches('.sp-tabs details') && event.target.open) {
          this.querySelectorAll('.sp-tabs details').forEach(details => { if (details !== event.target) details.open = false; });
        }
      },{...options,capture:true});
      this.addEventListener('change', event => {
        if (event.target.matches('[data-option-id]')) this.select(event.target);
      },options);
      this.addEventListener('click', async event => {
        const tab = event.target.closest('[role="tab"]');
        if (tab) this.activateTab(tab);
        const colorPreview = event.target.closest('.sp-option--color label');
        if (event.target.closest('.sp-colors-open') || colorPreview) {
          event.preventDefault(); this.openOptions(true); return;
        }
        if (event.target.closest('.sp-sizes-open')) { this.openOptions(false); return; }
        const pick = event.target.closest('[data-pick-id]');
        if (pick) {
          const radio = [...this.querySelectorAll('[data-option-id]')].find(el => el.id === pick.dataset.pickId);
          const parent = pick.closest('dialog'); parent.close();
          if (radio) { radio.checked = true; radio.dispatchEvent(new Event('change',{bubbles:true})); }
          return;
        }
        const zoom = event.target.closest('.sp-zoom');
        if (zoom) {
          const source = zoom.querySelector('img');
          const dialog = this.querySelector('.sp-lightbox');
          const img = dialog.querySelector('img');
          img.src = source.currentSrc || source.src; img.alt = source.alt;
          dialog.showModal();
        }
        if (event.target.closest('.sp-size-open')) this.querySelector('.sp-size-dialog')?.showModal();
        const close = event.target.closest('.sp-modal-close');
        if (close) close.closest('dialog').close();
        if (event.target.matches('dialog')) {
          const rect = event.target.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) event.target.close();
        }
        if (event.target.closest('.sp-share')) {
          const url = location.href;
          try {
            if (navigator.share) await navigator.share({title:document.title,url});
            else { await navigator.clipboard.writeText(url); this.querySelector('.sp-status').textContent = 'Ürün bağlantısı kopyalandı.'; }
          } catch (error) { if (error.name !== 'AbortError') this.querySelector('.sp-status').textContent = 'Bağlantıyı adres çubuğundan kopyalayabilirsiniz.'; }
        }
      },options);
    }
    activateTab(tab) {
      const scope = tab.closest('[data-sp-tabs]');
      scope.querySelectorAll('[role="tab"]').forEach(el => { const active = el === tab; el.setAttribute('aria-selected',String(active)); el.tabIndex = active ? 0 : -1; });
      scope.querySelectorAll('[role="tabpanel"]').forEach(el => el.hidden = el.id !== tab.getAttribute('aria-controls'));
    }
    openOptions(color) {
      const dialog = this.querySelector(color ? '.sp-color-dialog' : '.sp-sizes-dialog');
      const grid = dialog.querySelector(color ? '.sp-color-grid' : '.sp-size-grid');
      grid.replaceChildren();
      const related = this.querySelector('.sp-related-template');
      if (color && related) { grid.append(related.content.cloneNode(true)); dialog.showModal(); return; }
      const groups = [...this.querySelectorAll(color ? '.sp-option--color' : '.sp-option--size')];
      if (!groups.length) { this.querySelector('.sp-status').textContent = 'Bu üründe beden seçeneği bulunmuyor.'; return; }
      groups.forEach(group => {
        if (!color) { const title = document.createElement('h3'); title.textContent = group.querySelector('legend').textContent; grid.append(title); }
        group.querySelectorAll('.sp-value').forEach(value => {
          const input = value.querySelector('input'); const label = value.querySelector('label');
          const button = document.createElement('button'); button.type = 'button'; button.dataset.pickId = input.id;
          button.setAttribute('aria-pressed',String(input.checked));
          button.className = label.className;
          [...label.childNodes].forEach(node => button.append(node.cloneNode(true)));
          grid.append(button);
        });
      });
      dialog.showModal();
    }
    initGallery() {
      this.galleryObserver?.disconnect();
      const gallery = this.querySelector('.sp-gallery');
      const slides = [...gallery.querySelectorAll('.sp-media')];
      this.querySelector('.sp-gallery-dots')?.remove();
      if (slides.length < 2) return;
      const dots = document.createElement('div'); dots.className = 'sp-gallery-dots'; dots.setAttribute('aria-label','Ürün görselleri');
      slides.forEach((slide,i) => { const button = document.createElement('button'); button.type = 'button'; button.setAttribute('aria-label',`${i+1}. görsel`); button.setAttribute('aria-pressed',String(i===0)); button.addEventListener('click',()=>gallery.scrollTo({left:slide.offsetLeft,behavior:'smooth'})); dots.append(button); });
      gallery.after(dots);
      if ('IntersectionObserver' in window) {
        this.galleryObserver = new IntersectionObserver(entries => { entries.forEach(entry => { if (entry.isIntersecting) [...dots.children].forEach((button,i)=>button.setAttribute('aria-pressed',String(slides[i]===entry.target))); }); },{root:gallery,threshold:.6});
        slides.forEach(slide=>this.galleryObserver.observe(slide));
      }
    }
    async select(input) {
      this.request?.abort();
      const controller = new AbortController(); this.request = controller;
      const options = [...this.querySelectorAll('.sp-option input:checked')].map(el => el.dataset.optionId);
      const url = new URL(input.dataset.productUrl || this.dataset.url,location.origin);
      if (url.origin !== location.origin) return;
      url.searchParams.delete('variant');
      url.searchParams.set('option_values',options.join(','));
      url.searchParams.set('section_id',this.dataset.section);
      const status = this.querySelector('.sp-status');
      this.querySelector('.sp-add').disabled = true;
      this.querySelector('.sp-mobile-add').disabled = true;
      this.setAttribute('aria-busy','true');
      status.textContent = 'Seçenek güncelleniyor…';
      const timeout = setTimeout(() => controller.abort(),20000);
      try {
        const response = await fetch(url,{signal:controller.signal});
        if (!response.ok) throw new Error('Variant load failed');
        const doc = new DOMParser().parseFromString(await response.text(),'text/html');
        const updated = [...doc.querySelectorAll('sokids-product')].find(el => el.dataset.section === this.dataset.section);
        if (!updated) throw new Error('Product section missing');
        if (this.request !== controller || !this.isConnected) return;
        const focusId = input.id;
        const fragment = document.createDocumentFragment();
        [...updated.childNodes].forEach(node => fragment.append(document.importNode(node,true)));
        this.replaceChildren(fragment);
        this.initGallery();
        this.dataset.variant = updated.dataset.variant;
        this.dataset.url = updated.dataset.url;
        const nextUrl = new URL(updated.dataset.url,location.origin);
        if (updated.dataset.variant) nextUrl.searchParams.set('variant',updated.dataset.variant);
        else nextUrl.searchParams.set('option_values',options.join(','));
        history.replaceState({},'',nextUrl.pathname+nextUrl.search+location.hash);
        const focusTarget = input.closest('.sp-option--color') ? (this.querySelector('.sp-colors-open') || input) : [...this.querySelectorAll('[data-option-id]')].find(el => el.id === focusId);
        focusTarget?.focus({preventScroll:true});
        this.querySelector('.sp-status').textContent = updated.dataset.variant ? 'Seçenek güncellendi.' : 'Bu seçenek birleşimi mevcut değil. Başka bir renk veya numara seçin.';
      } catch (error) {
        if (this.request !== controller || !this.isConnected) return;
        // Keep buying disabled instead of adding the previously selected variant.
        status.textContent = 'Seçenek doğrulanamadı. Lütfen başka bir seçenek seçin veya sayfayı yenileyin.';
      } finally {
        clearTimeout(timeout);
        if (this.request === controller) this.removeAttribute('aria-busy');
      }
    }
    disconnectedCallback() { this.events?.abort(); this.events = null; this.request?.abort(); this.galleryObserver?.disconnect(); }
  });
})();
